import React from "react";
import { motion } from "framer-motion";
import { User, Store, Rocket, Building2, TrendingUp, HeartHandshake, Palette, Users } from "lucide-react";
import { SERVE } from "../data/content";
import { fadeUp, staggerContainer, viewportOnce, EYEBROW } from "../lib/motion";

const ICONS = { User, Store, Rocket, Building2, TrendingUp, HeartHandshake, Palette, Users };

export const Clients = () => {
  return (
    <section id="klien" data-testid="clients-section" className="relative bg-white py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="max-w-3xl"
        >
          <span className={EYEBROW}>Klien Kami</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-navy leading-[1.05] font-bold">
            Siapa yang <span className="italic text-gold-dark">Kami Layani?</span>
          </h2>
          <p className="mt-5 text-graytone-dark text-lg">
            Dari individu hingga korporasi, kami menyesuaikan pendekatan hukum dengan kebutuhan setiap klien.
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-5"
        >
          {SERVE.map((c, i) => {
            const Icon = ICONS[c.icon];
            return (
              <motion.div
                key={c.label}
                variants={fadeUp}
                data-testid={`client-${i}`}
                className="group flex flex-col items-center text-center rounded-3xl border border-graytone-medium/60 bg-graytone-light px-6 py-9 hover:border-gold/60 hover:bg-white hover:shadow-soft hover:-translate-y-1.5 transition-all duration-400"
              >
                <div className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-navy text-gold group-hover:bg-gold group-hover:text-navy transition-colors duration-300">
                  <Icon className="h-8 w-8" strokeWidth={1.6} />
                </div>
                <h3 className="mt-5 font-serif text-xl font-semibold text-navy">{c.label}</h3>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
